import { render } from "./PrinterKlipper.vue?vue&type=template&id=062a2662"
import script from "./PrinterKlipper.vue?vue&type=script&lang=js"
export * from "./PrinterKlipper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__